module.exports = __webpack_public_path__ + "h5/img/liwu.c46ae81e.png";